import type { PaymentDeliveryImage } from "../../aysa_api/models/payment_delivery_image.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseImage,
  encodeImage,
  decodeImage,
} from "../../aysa_api/models/image";
import {
  encodeLinkTarget,
  decodeLinkTarget,
} from "../../aysa_api/models/link_target";

export const createBasePaymentDeliveryImage = (): PaymentDeliveryImage => {
  return {
    image: createBaseImage(),
    deprecatedHref: "",
  };
};

export const decodePaymentDeliveryImage = (
  reader: Reader,
  length: number
): PaymentDeliveryImage => {
  const end = reader.pos + length;
  const message = createBasePaymentDeliveryImage();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.image = decodeImage(reader, reader.uint32());

        break;
      case 2:
        message.deprecatedHref = reader.string();

        break;
      case 3:
        message.link = decodeLinkTarget(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePaymentDeliveryImage = (
  writer: Writer,
  message: PaymentDeliveryImage
): Writer => {
  encodeImage(writer.uint32(10).fork(), message.image).ldelim();
  writer.uint32(18).string(message.deprecatedHref);
  if (message.link !== undefined) {
    encodeLinkTarget(writer.uint32(26).fork(), message.link).ldelim();
  }

  return writer;
};
